import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import { ItemImage } from '../ItemImage'
import { Price } from '../Price'
import { Location } from '../Location'

import translations from '../../../../../../public/data/translations.json'

export const Item = ({ item, isLoading }) => {
  const { lang } = useTranslation('common')
  const locale = lang?.toUpperCase() || 'ME'

  const {
    name,
    thumbnail,
    price,
    discounted_price,
    discount,
    group,
    product_description,
    availability,
    is_price_shown,
    product_code
  } = item

  const DescriptionGume = ({ product_description }) => {
    const width = product_description[0]?.value
    const height = product_description[1]?.value
    const diameter = product_description[2]?.value
    const season = product_description[3]?.value

    return (
      <ul>
        <li style={{ maxHeight: 'none' }}>
          <span className='oglasi-item-description__inline'>
            {width}/{height} R{diameter} <span style={{ marginLeft: 5, marginRight: 5 }}>&middot;</span> {season}
          </span>
        </li>
      </ul>
    )
  }

  const href = {
    pathname: '/vehiclePart',
    query: { slug: name?.slug }
  }

  const as = `/${translations.noviDjeloviUrl[locale]}/proizvod/${name?.slug}`

  return (
    <div className={`oglasi-item-tekst`} style={{ display: 'flex', flexDirection: 'column' }}>
      <ItemImage
        isLoading={isLoading}
        className='oglasi-item-tekst-img'
        img={`https://slikeprodavnica.autodiler.me${thumbnail}`}
        title={name?.name || ''}
        as={as}
        href={href}
      />

      {!isLoading ? (
        <Link as={as} href={href}>
          <a className='oglasi-item-heading oglasi-item-heading-vehicle-parts oglasi-item-heading__full'>
            <h3>{name?.name || ''}</h3>
          </a>
        </Link>
      ) : (
        <div>
          <a className='oglasi-item-heading oglasi-item-heading-vehicle-parts oglasi-item-heading__full' style={{ cursor: 'not-allowed' }}>
            <h3>{name?.name || ''}</h3>
          </a>
        </div>
      )}

      {group?.slug === 'gume' && Array.isArray(product_description) && product_description.length > 0 ? (
        <div className='oglasi-item-description' style={{ height: 'auto' }}>
          <DescriptionGume product_description={product_description} />
        </div>
      ) : (
        <div style={{ height: 22 }} className='oglasi-item-description' />
      )}

      <Price price={price} priceWithDiscount={discounted_price} availability={availability} is_price_shown={is_price_shown} />

      {product_code ? (
        <div className='vehicle-parts-list-code'>
          <p>Šifra artikla: {product_code}</p>
        </div>
      ) : null}
    </div>
  )
}

Item.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    }).isRequired,
    group: PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    }).isRequired,
    product_description: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })).isRequired,
    ean: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    discounted_price: PropTypes.string,
    discount: PropTypes.string,
    availability: PropTypes.shape({
      name: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    }).isRequired,
    is_price_shown: PropTypes.bool.isRequired
  }).isRequired,
  isLoading: PropTypes.bool.isRequired
}
